import { Tabs } from 'antd';
import React from 'react';
import ProfileSettings from './ProfileSettings';
import PasswordSettings from './PasswordSettings';

const items = [
  {
    key: '1',
    label: 'Profile',
    children: <ProfileSettings />,
  },
  {
    key: '2',
    label: 'Password',
    children: <PasswordSettings />,
  },
];

const Settings = () => {
  return (
    <div className="w-full h-full">
      <div className="flex flex-col p-5 ctable">
        <div className="flex pl-3 pb-2">
          <div className="flex gap-3 items-center mr-auto">
            <div className="text-[18px] font-[500]">Settings</div>
          </div>
        </div>
        <Tabs
          defaultActiveKey="1"
          items={items}
          className="pl-3"
          onChange={(key) => console.log('Active tab:', key)}
        />
      </div>
    </div>
  );
};

export default Settings;
